<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('translation.translations') }}</span>
        <h3 class="page-title">{{ $t('translation.translationsTitle') }}</h3>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('translation.systemName') }}</th>
            <th scope="col" class="border-0">{{ $t('translation.valueInPolish') }}</th>
            <th scope="col" class="border-0">{{ $t('translation.translationStatus') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(translation, index) of translations"
            :key="'translation-' + index">
            <td class="align-middle">
              {{ translation.value }}
            </td>
            <td
              class="align-middle"
              v-pure-html="translation.translation">
            </td>
            <td class="align-middle" v-pure-html="translationStatus(translation.translations)"></td>
            <td
              class="align-middle"
              style="width: 80px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/tlumaczenia/edycja/' + translation.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="translations.length === 0">
            <td
              colspan="3"
              class="text-center">
              {{ $t('translation.noTranslationsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'translations',
  mixins: [
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      translations: [],
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.loadData();
    }, 250),
    loadData () {
      ListUtils.loadPaginatedItemsData(this, {
        method: 'get',
        endpoint: '/customer-panel/translations/items?page=' + this.currentPage,
        listField: 'translations'
      });
    },
    translationStatus (translationsToCheck) {
      let isTranslated = true;
      let missingTranslationsCount = 0;

      for (let i = 0; i < translationsToCheck.length; i++) {
        let translation = translationsToCheck[i];

        if (!translation.translation) {
          isTranslated = false;
          missingTranslationsCount++;
        }
      }

      if (isTranslated) {
        return '<span class="text-success">' + this.$t('translation.translated') + '</span>';
      }

      if (missingTranslationsCount === 1) {
        return '<span class="text-danger">' + this.$t('translation.missingTranslationsIn') + '1 ' + this.$t('translation.languageLocative') + ' </span>';
      }

      return '<span class="text-danger">' + this.$t('translation.missingTranslationsIn') + missingTranslationsCount + ' ' + this.$t('translation.languagesLocative') + '</span>';
    }
  }
};
</script>
